import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Exclusivity } from "@faire/web/slate/icons/foundation/Exclusivity";
import React from "react";
import { SettingRetailerExclusivityIsOn } from "../visibilityFunctions/settingRetailerExclusivityVisibilityFn";
export var useExclusivityRetailerNodes = function useExclusivityRetailerNodes() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var articles = useArticles();
  return {
    Exclusivity: {
      id: "Exclusivity",
      label: strictLocalize({
        id: "NjU00Y",
        defaultMessage: [{
          "type": 0,
          "value": "Exclusiviteit"
        }]
      }),
      icon: /*#__PURE__*/React.createElement(Exclusivity, {
        fontSize: "24px",
        color: "faireBlack"
      }),
      articles: [articles.Account.WHAT_IS_EXCLUSIVITY],
      isNodeVisible: SettingRetailerExclusivityIsOn,
      level: 1,
      sidebarTitle: strictLocalize({
        id: "Oc9nC3",
        defaultMessage: [{
          "type": 0,
          "value": "Exclusiviteitsprobleem"
        }]
      })
    }
  };
};